'use strict';

var formValidation = require('./components/formValidation');

$(document).ready(function() {
    // submitProfile
    $('form.edit-profile-form').submit(function (e) {
        var $form = $(this);
        e.preventDefault();
        var url = $form.attr('action');
        $form.spinner().start();
        $('form.edit-profile-form').trigger('profile:edit', e);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                $form.spinner().stop();
                if (!data.success) {
                    formValidation($form, data);
                } else {
                    location.href = data.redirectUrl;
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
                $form.spinner().stop();
            }
        });
        return false;
    });

    // submitPassword
    $('form.change-password-form').submit(function (e) {
        var $form = $(this);
        e.preventDefault();
        var url = $form.attr('action');
        $form.spinner().start();
        $('form.change-password-form').trigger('password:edit', e);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                $form.spinner().stop();
                if (!data.success) {
                    formValidation($form, data);
                    $('form.change-password-form').find('#btn-save-pssw').prop('disabled', false);
                    $('form.change-password-form').find('#btn-show-pssw').prop('disabled', false);
                    $('form.change-password-form').find('#btn-show-newpssw').prop('disabled', false);
                    $('form.change-password-form').find('#btn-show-confpssw').prop('disabled', false);

                } else {
                    window.location.href = data.redirectUrl;
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
                $form.spinner().stop();
            }
        });
        return false;
    });
});
